import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { T } from 'src/shared/helpers';
import { Dialog, useDialogManager } from '../../../../widgets/dialog';
import { Checkbox } from '../../../../widgets/checkbox';

export interface DuplicateOptions {
    cloneTemplates: boolean;
    assignPricingRules: boolean;
}

const OptionsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 8px 0 16px;
`;

const DuplicateOptionsDialog: FC<{
    dialogId: string;
    onConfirm: (options: DuplicateOptions) => void;
    onCancel?: () => void;
}> = ({ dialogId, onConfirm, onCancel }) => {
    const [cloneTemplates, setCloneTemplates] = useState(false);
    const [assignPricingRules, setAssignPricingRules] = useState(false);
    const { closeDialog } = useDialogManager();

    const handleCancel = () => {
        closeDialog(dialogId);
        onCancel?.();
    };

    const handleConfirm = () => {
        closeDialog(dialogId);
        onConfirm({ cloneTemplates, assignPricingRules });
    };

    return (
        <Dialog
            title={T._('Duplication options', 'Admin')}
            onClose={handleCancel}
            buttons={[
                { label: T._('Cancel', 'Admin'), outline: true, onClick: handleCancel },
                { label: T._('Duplicate', 'Admin'), onClick: handleConfirm }
            ]}
        >
            <OptionsList>
                <Checkbox
                    checked={cloneTemplates}
                    onChange={setCloneTemplates}
                    label={T._('Copy Pre-Designed Templates', 'Admin')}
                    caption={T._('Copy the Pre-Designed Templates from the original product to the destination products.', 'Admin')}
                />
                <Checkbox
                    checked={assignPricingRules}
                    onChange={setAssignPricingRules}
                    label={T._('Assign Pricing Rules', 'Admin')}
                    caption={T._('Assign the same Pricing Rules used by the original product to the destination products.', 'Admin')}
                />
            </OptionsList>
        </Dialog>
    );
};

export default DuplicateOptionsDialog;
